import {
  maskPhoneNumberInput,
  setTouHref,
  determineConversionPage,
  submitHandler
} from '../leadform-validation';
import { validateAllFields } from '../validation/validateForm';
import forEachElement from '../selectors/forEachElement';

/**
 * Sets up the form validation and Ajax form submit
 *
 * @param {string} [leadformWrapperSelector = '.js-leadform'] Outermost wrapper class of leadform
 */
export const setUpFormValidation = function(leadformWrapperSelector = '.js-leadform') {
  maskPhoneNumberInput();
  setTouHref();

  // Initialize form validation on the registration form.
  // It has the name attribute "registration"
  forEachElement(`${leadformWrapperSelector} .form--lead`, form => {
    const conversionPage = determineConversionPage(form);

    form.addEventListener('submit', function(event) {
      event.preventDefault();
      if(validateAllFields(form)) {
        submitHandler(form, conversionPage);
      }
    });

  });
};

